export default __webpack_public_path__ + "static/media/4.222085d2.png";